import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

const StaffCard = ({ staff, onUpdate, onEdit, isArchived = false }) => {
  const [form, setForm] = useState({ ...staff });
  const today = moment().startOf('day');
  const expiry = moment(form.expiry, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
  const isExpiredByDate = expiry.isValid() && !expiry.isAfter(today);
  const isDeleted = form.deletedFlag || form.active === 0 || isExpiredByDate;
  const [policyData, setPolicyData] = useState(null)

  useEffect(() => {
    setPolicyData(JSON.parse(localStorage.getItem('policyData')))
  }, [])

  return (
    <div
      className={`p-4 border rounded-md shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-4
        ${!isArchived && isDeleted
          ? 'bg-red-100 border-red-500'
          : form.policy_staff_status === 'draft'
          ? 'bg-orange-100 border-orange-500'
          : 'bg-white border-gray-200'
        }`}
    >
      <div>
        <div className='flex items-center space-x-1'>
          <p className="font-semibold">{form.forename} {form.surname}</p>
          {!isArchived && !form.has_open_claim && isDeleted && (
            <span className="text-red-700 font-medium text-sm">(Deleted)</span>
          )}
        </div>
        <p className="text-sm">DOB: {moment(form.dob).format('DD/MM/YYYY')}</p>
        <p className="text-sm">Inception: {moment(form.inception).format('DD/MM/YYYY')}</p>
        <p className="text-sm text-red-800 flex items-center">
          Expire: {expiry.isValid() ? expiry.format('DD/MM/YYYY') : '—'} 
          {!isArchived && form.has_open_claim && (
            <span className="text-blue-700 font-medium text-xs pl-1">(Ongoing Absence)</span>
          )}
        </p>
      </div>

      <div className="flex items-center gap-4">
        <div className='flex items-center space-x-1'>
          <div className="text-sm font-semibold">{form.fte}</div>
          <span className="text-xs text-gray-500">FTE</span>
        </div>
        <div className="flex gap-2 text-sas">
          <FontAwesomeIcon
            icon={faEdit}
            className="cursor-pointer hover:text-sas-dark"
            onClick={() => onEdit(staff)}
          />
        </div>
      </div>
    </div>
  );
};

export default StaffCard;
